import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import VueLazyLoad from 'vue3-lazyload'
import { plugin, defaultConfig } from '@formkit/vue'
import VueScrollTo from 'vue-scrollto'
import { store } from './pinia'
import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'
import VueGtag from 'vue-gtag'
import { pageSpeedBumpGuard } from './components/composables/usePageSpeedBump'

export const Application = createApp(App)

// Application.use(VueGtag, {
//   config: { id: 'UA-41682333-1' }
// })

const vfm = createVfm()

Application.directive('scroll-to', VueScrollTo)
Application.use(router)
  .use(
    VueGtag,
    {
      config: {
        id: 'G-VFXXHH2PEX',
      },
    },
    router
  )
  .use(VueLazyLoad, {
    adapter: {
      loaded({
        // bindType,
        el,
        // naturalHeight,
        // naturalWidth,
        // $parent,
        // src,
        // loading,
        // error,
        // Init,
      }) {
        setTimeout(() => el.classList.add('loaded'), 100)
      },
    },
  })
  .use(plugin, defaultConfig)
  .use(store)
  .use(vfm)
  .mount('#app')
router.beforeEach(pageSpeedBumpGuard)
